/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedMaxStaffSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_MAX_STAFF')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class TierAdvancedMaxStaffSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedMaxStaffSettingParser.decode(input).map(res => new TierAdvancedMaxStaffSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedMaxStaffSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedMaxStaffSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedMaxStaffSettingParser.schema();
    }
}
